/* @jsx h */

import { cn } from "@lemmonhq/uikit";
import {} from "@lemmonhq/types";
import { defineComponent, h } from "vue";
import { TableVisualProps } from "./types";

export const CashierCell = defineComponent<
  Omit<TableVisualProps, "tableStatus">
>({
  name: "CashierCell",
  props: ["planConfig", "onFloorPlanCellChange", "tables", "onTableOpen"],
  setup(props) {
    return () => {
      return (
        <div class="relative w-full h-full flex items-center justify-center select-none">
          <div
            class="flex flex-col items-center justify-center gap-0.5 rounded-xl relative"
            style={{
              width: "100%",
              height: "100%",
              background: "var(--floor-plan-fixture-background)",
              boxShadow: "var(--floor-plan-fixture-shadow)",
              color: "var(--floor-plan-fixture-content)",
              overflow: "visible",
            }}
          >
            {/* Floating receipt/money symbols */}
            <div
              class="absolute inset-0 pointer-events-none"
              style="opacity: 0.85; overflow: visible;"
            >
              <span
                class="absolute"
                style="animation: cashierFloat1 5s ease-out infinite; left: 15%; font-size: clamp(0.7rem, 1.8cqi, 1.2rem);"
              >
                💵
              </span>
              <span
                class="absolute"
                style="animation: cashierFloat2 5.5s ease-out infinite 1.3s; left: 50%; font-size: clamp(0.7rem, 1.8cqi, 1.2rem);"
              >
                🪙
              </span>
              <span
                class="absolute"
                style="animation: cashierFloat3 4.8s ease-out infinite 2.6s; left: 78%; font-size: clamp(0.7rem, 1.8cqi, 1.2rem);"
              >
                💵
              </span>
            </div>
            <span
              class="material-symbols-outlined relative z-10"
              style="font-size: clamp(1.2rem, 3cqi, 2.5rem);"
            >
              point_of_sale
            </span>
            <span
              class="relative z-10"
              style="font-size: clamp(0.5rem, 1.2cqi, 0.65rem); letter-spacing: 0.1em; text-transform: uppercase; opacity: 0.6;"
            >
              Cashier
            </span>
            <style>{`
              @keyframes cashierFloat1 {
                0% { transform: translateY(110%) scale(0.7) rotate(0deg); opacity: 0; }
                10% { opacity: 1; transform: translateY(80%) scale(0.85) rotate(-5deg); }
                25% { transform: translateY(40%) scale(0.95) rotate(3deg) translateX(8%); }
                40% { transform: translateY(0%) scale(1) rotate(-4deg) translateX(-5%); }
                55% { transform: translateY(-40%) scale(1) rotate(6deg) translateX(12%); }
                70% { transform: translateY(-80%) scale(0.95) rotate(-3deg) translateX(5%); opacity: 0.9; }
                85% { transform: translateY(-140%) scale(0.9) rotate(8deg) translateX(18%); opacity: 0.5; }
                100% { transform: translateY(-200%) scale(0.85) rotate(12deg) translateX(25%); opacity: 0; }
              }
              @keyframes cashierFloat2 {
                0% { transform: translateY(110%) scale(0.7) rotate(0deg); opacity: 0; }
                10% { opacity: 1; transform: translateY(75%) scale(0.9) rotate(4deg); }
                25% { transform: translateY(35%) scale(0.95) rotate(-6deg) translateX(-10%); }
                40% { transform: translateY(-5%) scale(1) rotate(3deg) translateX(6%); }
                55% { transform: translateY(-50%) scale(1) rotate(-5deg) translateX(-8%); }
                70% { transform: translateY(-95%) scale(0.95) rotate(4deg) translateX(-15%); opacity: 0.85; }
                85% { transform: translateY(-150%) scale(0.9) rotate(-7deg) translateX(-22%); opacity: 0.45; }
                100% { transform: translateY(-210%) scale(0.85) rotate(-10deg) translateX(-30%); opacity: 0; }
              }
              @keyframes cashierFloat3 {
                0% { transform: translateY(115%) scale(0.7) rotate(0deg); opacity: 0; }
                10% { opacity: 1; transform: translateY(85%) scale(0.85) rotate(-3deg); }
                25% { transform: translateY(45%) scale(0.95) rotate(5deg) translateX(-6%); }
                40% { transform: translateY(5%) scale(1) rotate(-6deg) translateX(8%); }
                55% { transform: translateY(-35%) scale(1) rotate(4deg) translateX(-4%); }
                70% { transform: translateY(-75%) scale(0.95) rotate(-5deg) translateX(10%); opacity: 0.9; }
                85% { transform: translateY(-130%) scale(0.9) rotate(9deg) translateX(20%); opacity: 0.5; }
                100% { transform: translateY(-190%) scale(0.85) rotate(14deg) translateX(30%); opacity: 0; }
              }
            `}</style>
          </div>
        </div>
      );
    };
  },
});
